import React, { useContext, Fragment } from "react";
import { Row, Col, Card } from "react-bootstrap";

import { UserContext } from "../../context/userContext";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const LoginStatus = () => {
    const { user } = useContext(UserContext);
    const history = useHistory();

    const handleLogin = () => {
        history.push("/login");
    };

    return (
        <Card>
            <Card.Body>
                <Row className="justify-content-center">
                    {user.loggedIn ? (
                        <Fragment>
                            <Col xs="auto">
                                <Card.Text className="titles">
                                    Hola PopStar
                                </Card.Text>
                            </Col>
                            <Col xs="auto">
                                <Link className="titles" to="/perfil">
                                    {user.data.displayName}
                                </Link>
                            </Col>
                        </Fragment>
                    ) : (
                        <>
                            <Fragment>
                                <Col xs="6">
                                    <p className="titles">Hola extraño</p>
                                </Col>

                                <Col xs="3">
                                    <button
                                        className="button-text"
                                        onClick={handleLogin}
                                    >
                                        Acceder
                                    </button>
                                </Col>
                            </Fragment>
                        </>
                    )}
                </Row>
            </Card.Body>
        </Card>
    );
};

export default LoginStatus;
